import React, { useState } from 'react'
import { Query } from 'react-apollo'
import _ from 'lodash'
import ReactTable from 'react-table'
import {
  Div, H3, Loading, P,
} from 'konsys-ui'
import config from './config'
import { theme } from '../../../styles/_variables'
import { GET_USERS } from '../../../constants/graphql/query'
import './style-css.css'
import { Wrapper } from '../../../components/user-components'
import { status } from '../constants'

const { color } = theme

const Index = () => (
  <Div display='flex' flexDirection='column'>
    <Div display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
      <H3 bold color={color.primaryColor} margin='32px 0'>รายชื่อผู้ใช้</H3>
      {/* <Link to='/user/add'><Button text='Create' /></Link> */}
    </Div>
    <List />
  </Div>
)

export const List = () => {
  const [current, setCurrent] = useState(0)
  const [sorted, setSorted] = useState([{ id: 'userId', desc: false }])
  const [filtered, setFiltered] = useState([])

  return (
    <Wrapper overflow padding='0 0 40px 0' center>
      <Query
        query={GET_USERS}
        fetchPolicy='cache-and-network'
        variables={{
          limit: 5,
          offset: current * 5,
          orderBy: sorted[0].desc ? 'DESC' : 'ASC',
          orderField: sorted[0].id,
          ...filtered,
        }}
      >{({ data, loading, error }) => {
        if (loading && _.isEmpty(data)) return <Loading center='true' />
        if (error) return <P>เกิดข้อผิดพลาด</P>

        return (
          <Div>
            <ReactTable
              className='table'
              data={data.UserList.lists} // *
              resizable={false}
              columns={config.columns} // *
              minRows={5}
              manual
              // defaultPageSize={10}
              showPageSizeOptions={false}
              getTdProps={() => ({ disabled: true })} // *
              getTrProps={(state, rowInfo) => { // *
                if (rowInfo) {
                  return {
                    style: {
                      padding: '8px 0',
                      backgroundColor: '#ffffff',
                      borderLeft: rowInfo.original.status === status.ACTIVE
                        ? `3px solid ${color.success}`
                        : `3px solid ${color.error}`,
                    },
                  }
                } return {}
              }}
              previousText='ก่อนหน้า'
              nextText='ถัดไป'
              pageText='หน้า'
              ofText='จาก'
              noDataText='ไม่พบข้อมูล'
              page={current}
              pages={Math.ceil(data.UserList.totalFilter / 5)}
              onPageChange={page => setCurrent(page)}
              onFilteredChange={async (newFiltered) => {
                const newOjb = {}
                await newFiltered.forEach((v) => {
                  Object.assign(newOjb, { [v.id === 'Roles' ? 'roleId' : v.id]: v.value })
                })
                setFiltered(newOjb)
                setCurrent(0)
              }}
              onSortedChange={async (newSorted) => {
                setSorted(newSorted)
                setCurrent(0)
              }}
            />
            {
              loading && <Div margin='32px 0 0'><Loading center='true' /></Div>
            }
          </Div>
        )
      }}
      </Query>
    </Wrapper>
  )
}

export default Index
